class MeccaRecommendations extends HTMLElement {
  connectedCallback() {
    var self = this;
    var handleIntersect = function (entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(self);

      fetch(self.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('mecca-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            self.innerHTML = recommendations.innerHTML;
          }
          if (!self.querySelector('.mb-bestseller')) {
            self.remove();
          }
        })
        .catch(function () {
          self.remove();
        });
    };

    new IntersectionObserver(handleIntersect, { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('mecca-recommendations', MeccaRecommendations);
